export default __webpack_public_path__ + "static/media/CircularStd-Medium.38de5bd9.woff2";